import {Component} from "preact";
import styles from './styles.scss';
import Toolbar from "../../../../../layout/toolbar";
import ToolbarButton from "../../../../../common/toolbar-button";
import LetterIcon from "../../../../../common/letter-icon";
import ConfigService from "../../../../../../services/ConfigService";

export default class ChatListItem extends Component {
    static defaultProps = {
        item: {},
        onClick: () => {}
    };

    render(props, state, context) {
        const classes = [styles.container];
        if (!props.item.read) classes.push(styles.unread);

        const title = this.getChatTitle(props.item);
        const subtitle = () => (props.item.lastMessage) ? <div class={styles.subtitle}>{props.item.lastMessage.content}</div> : null;

        return (
            <Toolbar class={styles.toolbar}>
                <ToolbarButton type={'fill text'} onClick={this.props.onClick}>
                    <div class={classes.join(' ')}>
                        <div class={styles.icon}><LetterIcon text={title}/></div>
                        <div class={styles.body}>
                            <div class={styles.title}>{title}</div>
                            {subtitle()}
                        </div>
                    </div>
                </ToolbarButton>
            </Toolbar>
        );
    }

    getChatTitle(item) {
        if (item.title) return item.title;
        const userReference = ConfigService.userProfile().reference;
        const subject = item.subjects.filter(s => s.reference !== userReference)[0];
        return subject.name || subject.email;
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/chat-list-item/index.js